"use client";
import * as React from "react";
const SvgEvStationSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.38 3.76 10.23.43l-.9.95 1.8 1.87c-.9.36-1.5 1.3-1.35 2.41a2.2 2.2 0 0 0 1.87 1.88 2 2 0 0 0 1.08-.18v7.3h-1.7V8H8.49V0H0v16h8.49V9.33h1.27V16H14V5.33c0-.61-.24-1.17-.62-1.57m-1.5 2.46c-.47 0-.85-.4-.85-.89s.38-.89.85-.89.85.4.85.9c0 .48-.38.88-.85.88M3.4 13.33v-4H1.7l3.4-6.66V7.1h1.69z" }));
export {
  SvgEvStationSharp as default
};
